import { EngineState } from '../state';

export const getNudgeById = (engine: EngineState['engine'], id: string | number) =>
  engine.nudgeServices.get(String(id))?.getSnapshot().context.nudge ||
  engine.nudgeServices.get(`old-${id}`)?.getSnapshot().context.nudge;
